export const DISPATCH_LOG_HELP_DOMAIN = "dispatch-log" as const;

export const DISPATCH_LOG_HELP_SCREENS = {
  form: "dispatch-log.form",
  list: "dispatch-log.list",
} as const;

export const DISPATCH_LOG_FORM_HELP_KEYS = {
  property: "dispatch-log.form.property",
  household: "dispatch-log.form.household",
  dispatchLogType: "dispatch-log.form.dispatch_log_type",
  name: "dispatch-log.form.name",
  callbackNumber: "dispatch-log.form.callback_number",
  details: "dispatch-log.form.details",
  images: "dispatch-log.form.images",
  createAutomaticDar: "dispatch-log.form.create_automatic_dar",
  sendNotification: "dispatch-log.form.send_notification",
  submit: "dispatch-log.form.submit",
} as const;

export const DISPATCH_LOG_LIST_HELP_KEYS = {
  search: "dispatch-log.list.search",
  filters: "dispatch-log.list.filters",
  new: "dispatch-log.list.new",
  rows: "dispatch-log.list.rows",
  /** @deprecated Prefer per-action keys; kept for tour fallbacks */
  row: "dispatch-log.list.row",
  rowActions: "dispatch-log.list.row_actions",
  actionView: "dispatch-log.list.action_view",
  actionDelete: "dispatch-log.list.action_delete",
} as const;

export const DISPATCH_LOG_HELP_TOURS = {
  listIntro: "dispatch-log.list.intro",
  formCreate: "dispatch-log.form.create",
} as const;
